export default __webpack_public_path__ + "static/sc-policyguru-d47a588e0c58e882a08f5fc67605275f.webp";